import { useEffect, useRef, useState } from "react";

const STEPS = [10, 30, 50, 70, 90];
const STEP_INTERVAL_MS = 400;
const COMPLETE_HOLD_MS = 250;

// Returns the current loading-progress percent for StewartTable.
// While `isLoading` is true: emits 10 immediately, advances 30/50/70/90 on
// a 400 ms cadence, then holds at 90. When `isLoading` flips false (after
// having been true): briefly shows 100, then resolves to undefined so the
// bar disappears. Initial-mount false stays undefined (no 100 flash).
export function useSteppedProgress(isLoading: boolean): number | undefined {
  const [percent, setPercent] = useState<number | undefined>(undefined);
  const wasLoadingRef = useRef(false);

  useEffect(() => {
    if (isLoading) {
      wasLoadingRef.current = true;
      let i = 0;
      setPercent(STEPS[0]);
      const id = setInterval(() => {
        i += 1;
        if (i < STEPS.length) {
          setPercent(STEPS[i]);
        } else {
          clearInterval(id);
        }
      }, STEP_INTERVAL_MS);
      return () => clearInterval(id);
    }
    if (wasLoadingRef.current) {
      setPercent(100);
      const t = setTimeout(() => setPercent(undefined), COMPLETE_HOLD_MS);
      return () => clearTimeout(t);
    }
  }, [isLoading]);

  return percent;
}
